import { ConnectionType } from '@capacitor/network';
import { createAction } from '@reduxjs/toolkit';

interface NetworkStateChangedPayload {
  /** The current network status of the device. */
  networkState: ConnectionType;
}
/** An action that is dispatched when the device network state changes. */
const networkStateChanged = createAction<NetworkStateChangedPayload>('APP.NETWORK_STATE.CHANGED');

/** An action that is dispatched when the side menu should be togged. */
const toggleSideMenu = createAction('APP.SIDE_MENU.TOGGLE');

export const commonActions = {
  networkStateChanged,
  toggleSideMenu,
};
